import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { reelMessages } from './reelMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole AI reel flow; each part uses its own slice of it */
import styles from './PromoteReels.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The "AI reel · 9:16" chip on the right of the page head (design a1, b1). */
const ReelAiChipComponent: React.FC = () => {
  const intl = useIntl();
  return <span className={styles.aiChip}>{intl.formatMessage(reelMessages.aiChip)}</span>;
};

export const ReelAiChip = TypedMemo(ReelAiChipComponent);
